export const TAG_LOADING = 'TAG_LOADING';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAG_SUCCESS = 'GET_TAG_SUCCESS';
export const ADD_TAG_SUCCESS = 'ADD_TAG_SUCCESS';
export const UPDATE_TAG_SUCCESS = 'UPDATE_TAG_SUCCESS';
export const DELATE_TAG_SUCCESS = 'DELATE_TAG_SUCCESS';
export const RESET_TAG = 'RESET_TAG';
export const RESET_TAGS = 'RESET_TAGS';
